import { CommonFieldName } from "@app/shared/constants";
import { DateTimeFormatStrings, DriverDataBusinessType } from "@app/shared/enums";
import { CommonPageFilterSetting, CommonSearchCriteria } from "@app/shared/models/common-data.model";
import { Utilities } from "@app/shared/utils/utilities";

export class SmartSearchHelper {
  static CreateDatePeriodQueryString(searchCriteria: CommonSearchCriteria) {
    var monthList = Utilities.getLastMonthByNumber(searchCriteria.searchValue as number);
    return `${searchCriteria.searchBy}=${encodeURIComponent(monthList[0])}&${searchCriteria.searchBy}=${encodeURIComponent(monthList[1])}`;
  }

  static CreateDateQueryString(searchCriteria: CommonSearchCriteria) {
    const start = Utilities.formatDate(new Date(searchCriteria.searchValueStart), DateTimeFormatStrings.FORMAT_6);
    const end = Utilities.formatDate(new Date(searchCriteria.searchValueEnd), DateTimeFormatStrings.FORMAT_6);
    return `${searchCriteria.searchBy}=${encodeURIComponent(start)}&${searchCriteria.searchBy}=${encodeURIComponent(end)}`;
  }

  static CreateDateTimeQueryString(searchCriteria: CommonSearchCriteria) {
    const start = Utilities.formatDate(new Date(searchCriteria.searchValueStart), DateTimeFormatStrings.FORMAT_9);
    var endDate = new Date(searchCriteria.searchValueEnd);
    endDate.setHours(23, 59, 59);
    const end = Utilities.formatDate(endDate, DateTimeFormatStrings.FORMAT_9);
    return `${searchCriteria.searchBy}=${encodeURIComponent(start)}&${searchCriteria.searchBy}=${encodeURIComponent(end)}`;
  }

  static CreateUTCDateTimeQueryString(searchCriteria: CommonSearchCriteria) {
    const start = Utilities.formatDate(new Date(searchCriteria.searchValueStart), DateTimeFormatStrings.FORMAT_10);
    const end = Utilities.formatDate(new Date(searchCriteria.searchValueEnd), DateTimeFormatStrings.FORMAT_10);
    return `${searchCriteria.searchBy}=${encodeURIComponent(start)}&${searchCriteria.searchBy}=${encodeURIComponent(end)}`;
  }

  static CreateBusinessTypeQueryString(searchCriteria: CommonSearchCriteria) {
    if (searchCriteria.searchValue === DriverDataBusinessType.LB_MB) {
      return `${searchCriteria.searchBy}=${DriverDataBusinessType.LB}&${searchCriteria.searchBy}=${DriverDataBusinessType.MB}`;
    } else {
      var queryValue = Utilities.getQueryStringValueFromInput(searchCriteria.searchValue as string | string[]);
      return Utilities.isEmptyString(queryValue) ? "" : `${searchCriteria.searchBy}=${encodeURIComponent(queryValue)}`;
    }
  }

  static CreateSpecifiedFuzzyQueryString(criterion: CommonSearchCriteria) {
    return `${criterion.searchBy}=${encodeURIComponent("%")}${criterion.searchValue}`;
  }

  static CreateFuzzyQueryString(searchCriteria: CommonSearchCriteria) {
    var queryValue = Utilities.getQueryStringValueFromInput(searchCriteria.searchValue as string | string[]);
    return searchCriteria.searchBy !== "" && queryValue !== "" ? `${encodeURIComponent(searchCriteria.searchBy)}=${encodeURIComponent("%" + queryValue + "%")}` : "";
  }

  static CreateDefaultQueryString(searchCriteria: CommonSearchCriteria) {
    if (searchCriteria.searchBy === CommonFieldName.lastModified_On && searchCriteria.searchValueStart && searchCriteria.searchValueEnd) {
      return SmartSearchHelper.CreateDateTimeQueryString(searchCriteria);
    }

    var queryValue = Utilities.getQueryStringValueFromInput(searchCriteria.searchValue as string | string[]);
    return !Utilities.isEmptyString(searchCriteria.searchBy) && !Utilities.isEmptyString(queryValue)
      ? `${encodeURIComponent(searchCriteria.searchBy)}=${encodeURIComponent(queryValue)}`
      : "";
  }

  static CreatePagingFilteringQueryString(pageFilterInfo: CommonPageFilterSetting) {
    if (!pageFilterInfo) {
      return "";
    }

    var queryStringList: string[] = [];
    if (!Utilities.isEmptyString(pageFilterInfo.sortBy)) {
      queryStringList.push(`OrderBy=${encodeURIComponent(pageFilterInfo.sortBy)}`);
    }

    if (!Utilities.isEmptyString(pageFilterInfo.sortDirection)) {
      queryStringList.push(`sorting=${pageFilterInfo.sortDirection}`);
    }

    if (pageFilterInfo.pageSize !== 0) {
      queryStringList.push(`Limit=${pageFilterInfo.pageSize}`);
    }

    if (pageFilterInfo.pageSize !== 0) {
      queryStringList.push(`Offset=${pageFilterInfo.pageSize * pageFilterInfo.pageIndex}`);
    }

    return queryStringList.join("&");
  }

  static CreateQueryString(searchCriteria: CommonSearchCriteria[], pageFilterInfo: CommonPageFilterSetting, extraCriteriaGenerate?: (criterion: CommonSearchCriteria) => string) {
    var queryStringList: string[] = [];
    searchCriteria.forEach((criterion) => {
      var queryString = extraCriteriaGenerate ? extraCriteriaGenerate(criterion) : "";
      queryStringList.push(queryString !== "" ? queryString : this.CreateDefaultQueryString(criterion));
    });

    return this.GenerateQueryStringWithPageFilter(queryStringList, pageFilterInfo);
  }

  static GenerateQueryStringWithPageFilter(queryStringList: string[], pageFilterInfo?: CommonPageFilterSetting) {
    queryStringList.push(this.CreatePagingFilteringQueryString(pageFilterInfo));
    var queryString = queryStringList.filter((item) => !Utilities.isEmptyString(item)).join("&");
    return queryString !== "" ? `?${queryString}` : "";
  }

  static IsSameSearchCriteriaList(oldCriteria: CommonSearchCriteria[], newCriteria: CommonSearchCriteria[]) {
    if (!oldCriteria || !newCriteria || oldCriteria.length !== newCriteria.length) {
      return false;
    }

    var isSame = true;
    oldCriteria.forEach((oldItem, index) => {
      if (oldItem.searchBy !== newCriteria[index].searchBy) {
        isSame = false;
      }
    });

    return isSame;
  }
}
